import React from "react";

/**
 * Builds the array of items to render.
 * e.g. for page 5 of 10: [1, '...', 4, 5, 6, '...', 10]
 */
const getPages = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = [];
  const addEllipsis = () => pages.push("...");

  pages.push(1);

  if (current <= 4) {
    pages.push(2, 3, 4, 5);
    addEllipsis();
  } else if (current >= total - 3) {
    addEllipsis();
    pages.push(total - 4, total - 3, total - 2, total - 1);
  } else {
    addEllipsis();
    pages.push(current - 1, current, current + 1);
    addEllipsis();
  }

  pages.push(total);
  return pages;
};

const ArrowLeft = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
    <path
      d="M3.476 5.331L5.719 3.022a.55.55 0 0 0-.004-1.073.55.55 0 0 0-.39.157L1.213 5.331a.55.55 0 0 0 0 .777l4.112 3.225a.55.55 0 0 0 .778-.777L3.476 5.331Z"
      fill="#626262"
    />
    <path d="M2.5 5.72h6.5" stroke="#626262" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

const ArrowRight = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
    <path
      d="M7.524 5.331L5.281 3.022a.55.55 0 0 1 .004-1.073.55.55 0 0 1 .39.157l4.112 3.225a.55.55 0 0 1 0 .777L5.675 9.333a.55.55 0 0 1-.778-.777l2.627-3.225Z"
      fill="#626262"
    />
    <path d="M8.5 5.72H2" stroke="#626262" strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = getPages(currentPage, totalPages);

  const go = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  return (
    <div className="qp-pagination">
      {/* Prev */}
      <button
        className="qp-page-btn qp-page-arrow"
        onClick={() => go(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        <ArrowLeft />
      </button>

      {pages.map((p, i) =>
        p === "..." ? (
          <span key={`ellipsis-${i}`} className="qp-page-ellipsis">
            &bull;&bull;&bull;
          </span>
        ) : (
          <button
            key={p}
            className={`qp-page-btn${p === currentPage ? " qp-page-active" : ""}`}
            onClick={() => go(p)}
            aria-current={p === currentPage ? "page" : undefined}
          >
            {p}
          </button>
        )
      )}

      {/* Next */}
      <button
        className="qp-page-btn qp-page-arrow"
        onClick={() => go(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        <ArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
